import CryptoJS from 'crypto-js';

const password = 'rdxHsW4Cg27yIAjE0nmELMvrpapJzJD3';
const iv = 'rDaFHH76C0B2YhUl';

export function encrypt(text) {
    const encrypt = text + "-" + new Date().getTime()

    var ciphertext = CryptoJS.AES.encrypt(encrypt, CryptoJS.SHA256(CryptoJS.enc.Utf8.parse(password)), {
        iv: CryptoJS.SHA256(CryptoJS.enc.Utf8.parse(iv)),
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC
    }).toString();

    return ciphertext;
}

export function decrypt(text) {
    var ciphertext = CryptoJS.AES.decrypt(text, password, {
        iv: iv,
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC
    });

    return ciphertext.toString(CryptoJS.enc.Utf8);
}